<template>
  <div id="app">
    <!-- <loading
		:active.sync="$store.state.$loading"
		:can-cancel="false"
		:is-full-page="true"
		loader="dots"
		color="#f87675">
    </loading> -->

    <loadingCircle :active="$store.state.$loading"></loadingCircle>


    <router-view />
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";
// import "vue-loading-overlay/dist/vue-loading.css";

import loadingCircle from './components/component-share/layout/loading-circle/loading.vue'

export default {
  components: {
    loadingCircle,
  },
};
</script>

<style lang="scss">
</style>
